<template>
    <div>
        <el-table :data="tableData" height="300px">
            <el-table-column label="规格" min-width="140px">
                <template slot-scope="scope">
                    <div>{{$common.specTypeShow(scope.row.color,scope.row.size)}}</div>
                </template>
            </el-table-column>
            <el-table-column :label="$global.pack+'数'" width="160px" v-if="$global.buyType!=2">
                <template slot-scope="scope">
                    <InNumber
                        :datainfo="scope.row"
                        :dataKey="'count'"
                        :miniType="true"
                        @changeEnd="changeEnd($event,scope.row,'count')"
                        :comWidth='140'
                    ></InNumber>
                </template>
            </el-table-column>
            <el-table-column :label="$global.unit+'数'" width="160px" v-if="$global.buyType!=1">
                <template slot-scope="scope">
                    <InNumber
                        :datainfo="scope.row"
                        :dataKey="'num'"
                        :miniType="true"
                        :comWidth='140'
                        @changeEnd="changeEnd($event,scope.row,'num')"
                    ></InNumber>
                </template>
            </el-table-column>
            <el-table-column
                prop="price"
                label="价格"
                width="80px"
                v-if="$global.showProductPrice"
            ></el-table-column>
            <el-table-column
                prop="unit"
                label="包装数量"
                width="100px"
            >
                <template slot-scope="scope">
                    <div>{{scope.row.unit+$global.unit+'/'+$global.pack}}</div>
                </template>
            </el-table-column>
        </el-table>
        <div slot="footer" class="footclass">
            <div
                style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                "
            >
                <div class="totalBuy">
                    <div>
                        合计数量：<span class="blue">{{ getCount }}</span>
                    </div>
                    <div v-if="$global.showProductPrice">
                        合计金额：<span class="blue">￥{{ getCost }}元</span>
                    </div>
                </div>
                <div>
                    <!-- <div>
                        <el-button size="mini">统一数量</el-button>
                        <el-button size="mini" @click="moreBuyDialog = false">放弃</el-button>
                    </div> -->
                    <div class="mt-5">
                        <el-button type="primary" @click="close">关闭</el-button>
                        <el-button type="primary" v-if="hasshopingcart" @click="addToShopingcart()">加入购物车</el-button>
                        <el-button type="primary" @click="addMore()" v-else>立即下单</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tableData: {
            type: Array,
            default: function () {
                return [];
            },
        },
        hasshopingcart:{
            type:Boolean,
            default:false,
        },
        packing:{
            type:String,
            default:'件'
        },
    },
    data() {
        return {
        };
    },
    computed:{
        getCount() {
            let number = 0;
            this.tableData.forEach((e) => {
                if (e.num != null) {
                    let tnum = parseInt(e.num);
                    if (!tnum) {
                        tnum = 0;
                    }
                    number += tnum;
                }
                if(e.count!=null){
                    let tcount = parseInt(e.count);
                    if (!tcount) {
                        tcount = 0;
                    }
                    number += tcount*e.unit;
                }
            });
            return number;
        },
        getCost() {
            let sum = 0;
            this.tableData.forEach((e) => {
                if (e.num != null) {
                    sum += e.num * e.price;
                }
                if(e.count !=null){
                    sum += e.count * e.price * e.unit;
                }
            });
            return sum.toFixed(2);
        },
    },
    methods: {
        close(){
            this.$emit('close');
        },
        changeEnd(e,row,val){
            row[val] = e;
            this.$emit("updateNum",row.id);
        },
        addMore(){
            this.$emit("addMore",false);
        },
        addToShopingcart(){
            this.$emit("addToShopingcart");
        }
    },
};
</script>

<style scoped lang='scss'>
.footclass{
    padding-top: 20px;
    height: 50px;
}
.totalBuy {
    font-size: 13px;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #667280;
    text-align: left;
    line-height: 24px;

    .blue {
        color: #1F8FFF;
    }
}
.mt-5 {
	margin-top: 5px;
}
</style>